import React, { Component } from 'react';
import './Menu.scss';
import logo from '../../img/appart-me.png';
import arrow from '../../img/arrow.svg';
import { Link } from 'react-router-dom';
import data from '../../components/magazine.json';

let nextbutton = '';
let prevbutton = '';
let prevpossible = false;
let nextpossible = true;
let nextURL = {
  pathname: nextbutton,
  state: { next: nextpossible }
};
let prevURL = {
  pathname: prevbutton,
  state: { prev: prevpossible }
};

class Menu extends Component {

  componentDidMount(){
    nextbutton = this.props.nextbutton;
    prevbutton = this.props.prevbutton;

    prevURL = {
      pathname: prevbutton,
      state: { }
    };

    nextURL = {
      pathname: nextbutton,
      state: { }
    }
  }
  componentDidUpdate(prevProps){

    nextbutton = this.props.nextbutton;
    prevbutton = this.props.prevbutton;

    prevURL = {
      pathname: prevbutton,
      state: { prevpossible: prevpossible }
    };

    nextURL = {
      pathname: nextbutton,
      state: { nextpossible: nextpossible }
    };

    if (this.props.nextbutton !== prevProps.nextbutton) {
      this.setState({
        prev: false
      });
    }

  }
  render() {
    return (
      <div>
      <nav className="navbar">
      <Link to={{
          pathname: '/appart-me/editie-9/',
          state: { prev: false },
        }}
        className="navbar-brand"><img src={ logo } alt="logo"/></Link>
        <button className="navbar-toggler hamburger hamburger--elastic" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon hamburger-box">
            <span className="hamburger-inner"/>
          </span>
        </button>

        <div className="collapse navbar-collapse">
          <div className="inner-wrapper d-flex align-items-center justify-content-center">
            <ul className="navbar-nav mx-auto">
              <Link to={{
                pathname: '/appart-me/editie-9/',
                state: { prev: false },
              }}
              className="nav-link">Introductie</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/overzicht-editie-9',
                state: { prev: false },
              }}
              className="nav-link">Overzicht Editie 9</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/astrael-is-anders-met-ambitie-en-dromen',
                state: { prev: false },
              }}
              className="nav-link">{ data.magazine.pages[0]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/duurzaamheid-kent-geen-tijd-brauer-groen-over-de-volgende-stap-in-groenbeheer',
                state: { prev: false },
              }}
              className="nav-link">{ data.magazine.pages[1]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/een-andere-kijk-op-een-duurzame-toekomst',
                state: { prev: false },
              }}
              className="nav-link">{ data.magazine.pages[2]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/behandelingen-voor-elk-huidtype-dat-verdient-een-schoonheidsprijs',
                state: { prev: false },
              }}
              className="nav-link">{ data.magazine.pages[3]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/partners-voor-service',
                state: { prev: false },
              }}
              className="nav-link">{ data.magazine.pages[4]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/mensen-uitdagen-om-tot-het-uiterste-te-gaan',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[5]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/van-onvoorstelbaar-naar-onweerstaanbaar-extended-reality-xr-maakt-het-verschil',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[6]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/influencers-bestaan-al-veel-langer-alleen-werden-ze-niet-zo-genoemd',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[7]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/5-tips-voor-het-gebruik-van-humor-op-social-media',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[8]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/space32-door-de-ogen-van-appart',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[9]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/space32-volgens-bart-jansen-het-is-voor-mij-een-denktank-van-twee-bedrijven-die-elkaar-aanvullen',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[10]["intro-title"] }</Link>
              <Link to={{
                pathname: '/appart-me/editie-9/designer-aan-het-woord-de-gedachte-achter-het-logo-van-space32',
                state: { prev: false },
              }}
                    className="nav-link">{ data.magazine.pages[11]["intro-title"] }</Link>
            </ul>
          </div>
        </div>

        <div className="navigation">
          <div className={"next d-flex align-items-center justify-content-center " + (this.props.nextpossible ? 'active' : 'disabled')}>
            <Link to={{ pathname: nextbutton, state: { prev: false, nextpossible: nextpossible }, }}>
              <i className="far fa-arrow-right"/>
            </Link>
          </div>
          <div className={"prev d-flex align-items-center justify-content-center " + (this.props.prevpossible ? 'active' : 'disabled')}>
          <Link to={{ pathname: prevbutton, state: { prev: true, prevpossible: prevpossible }, }}>
            <i className="far fa-arrow-left"/>
          </Link>
          </div>
        </div>

      </nav>
      </div>
    )
  }

}

export default Menu;
